import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class FullDasboardTrilhasAprendizagem extends Serializable {
    @jsonProperty(Number)
    iniciados: number = 0;

    @jsonProperty(Number)
    concluidos: number = 0;

    @jsonProperty(Number)
    naoIniciados: number = 0;

    constructor() {
        super();
    }
}

export default FullDasboardTrilhasAprendizagem;
